export const types = {
  SET_SESSION: 'SET_SESSION',
  REMOVE_SESSION: 'REMOVE_SESSION',
  SET_USER: 'SET_USER',
  SET_WEEKLY_WORKING_HOURS: 'SET_WEEKLY_WORKING_HOURS'
}



// WEBPACK FOOTER //
// ./src/features/session/store/types.js